function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisaBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 25,
  viewBox: "0 0 35 25"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 23.18,
  x: 0.5,
  y: 0.5,
  rx: 3.5,
  ry: 3.5,
  style: {
    fill: "#fff",
    stroke: "#d9d9d9"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.63 16.38H8.51l-1.59-6.11c-.08-.28-.24-.53-.47-.65-.59-.29-1.24-.53-1.94-.65v-.24h3.42c.47 0 .82.35.88.76l.82 4.41 2.12-5.17h2.06l-3.18 7.64Zm4.36 0h-2l1.65-7.64h2zm4.24-5.52c.06-.41.41-.65.82-.65.65-.06 1.35.06 1.94.35l.35-1.65c-.59-.24-1.24-.35-1.83-.35-1.94 0-3.36 1.06-3.36 2.53 0 1.12 1 1.7 1.71 2.06.77.35 1.06.59 1 .94 0 .53-.59.76-1.18.76-.71 0-1.41-.18-2.06-.47l-.35 1.65c.71.29 1.47.41 2.18.41 2.18.06 3.53-1 3.53-2.59 0-2-2.77-2.12-2.77-3Zm9.78 5.52-1.59-7.64h-1.71c-.35 0-.71.24-.83.59l-2.94 7.05H24l.41-1.12h2.53l.24 1.12zm-3-5.58.59 2.88h-1.65z",
  style: {
    fill: "#172b85",
    fillRule: "evenodd"
  }
}));
export default SvgVisaBox;